/*
 * TFX Unique Products
 * Objective: move section line-fill behavior out of inline Liquid markup.
 * Scope: sections/tfx-unique-products.liquid
 * Dependencies: none
 * Date: 2026-03-07
 * Rollback: remove this file and restore the inline script in the section.
 */
(function () {
  var INIT_KEY = '__tfxUniqueProductsLineFillInit';
  if (window[INIT_KEY]) {
    window[INIT_KEY]();
    return;
  }

  var ticking = false;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function updateSection(section) {
    var listWrap = section.querySelector('.tfx-unique-products__list-wrap');
    if (!listWrap) return;

    var rect = listWrap.getBoundingClientRect();
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    var start = rect.top + window.scrollY;
    var end = rect.bottom + window.scrollY;
    var cursor = window.scrollY + viewport * 0.55;
    var progress = (cursor - start) / Math.max(1, end - start);
    var percent = clamp(progress, 0, 1) * 100;

    listWrap.style.setProperty('--tfx-line-fill', percent + '%');
  }

  function updateAll() {
    document.querySelectorAll('[data-tfx-section="unique-products"]').forEach(updateSection);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      updateAll();
      ticking = false;
    });
  }

  window[INIT_KEY] = updateAll;
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', onScroll);
  document.addEventListener('shopify:section:reorder', onScroll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onScroll, { once: true });
  } else {
    onScroll();
  }
})();
